import { useMutation } from '@tanstack/react-query';
import { ambientApi } from 'src/services';

export type UseLinkAppointmentDocumentsPayload = {
  appointmentId: number;
  documentIds: string[];
};

export type UseUnlinkAppointmentDocumentsPayload =
  UseLinkAppointmentDocumentsPayload;

export const useLinkAppointmentDocuments = () => {
  return useMutation({
    mutationFn: (payload: UseLinkAppointmentDocumentsPayload) =>
      ambientApi
        .post(`/appointments/${payload.appointmentId}/link_document`, {
          document_ids: payload.documentIds,
        })
        .then(({ data }) => data),
  });
};

export const useUnlinkAppointmentDocuments = () => {
  return useMutation({
    mutationFn: (payload: UseUnlinkAppointmentDocumentsPayload) =>
      ambientApi
        .post(`/appointments/${payload.appointmentId}/unlink_document`, {
          document_ids: payload.documentIds,
        })
        .then(({ data }) => data),
  });
};
